import { paperCheckListItems } from '@shared/enums';

export const paperCheckList = [
  paperCheckListItems.Secure,
  paperCheckListItems.Fast,
  paperCheckListItems.Online,
  paperCheckListItems.EcoFriendly,
];
